export const javaDefault = `public class Main {
    public static void main(String[] args) {
        System.out.println("FAST. GOOD. CHEAP. Choose any two.");
    }
  }`;

export const pyDefault = `print("Truth can only be found in one place: the code.")`;

export const jsDefault = `console.log("The best way to get a project done faster is to start sooner.")`;

export const csDefault = `using System;

  public class HelloWorld
  {
      public static void Main(string[] args)
      {
          Console.WriteLine ("Code is like humor. When you have to explain it, it’s bad.");
      }
  }`;

export const golangDefault = `// You can edit this code!
package main

import "fmt"

func main() {
	fmt.Println("Go will make you love programming again.")
}
`;

export const rustDefault = `fn main() {
    println!("Always code as if the guy who ends up maintaining your code will be a violent psychopath who knows where you live.");
}`;
